import "./Login.scss";
import base64url from "base64url";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import jwt from "jsonwebtoken";
import router from "@/router";
import EoHeimatIcon from "../../customIcons/EoHeimatIcon.vue";

export default {
  name: "login",
  components: { EoHeimatIcon },
  data: () => ({
    username: "",
    password: "",
    pwForgotten: false,
    changePwEmail: "",
    sendingEmail: false
  }),
  props: {
    prev: {},
    redirect: {
      default: true
    }
  },
  async mounted() {
    await this.$store.dispatch("getGlobalEoConfig");
  },
  methods: {
    async login(username, password, context = null) {
      if (context) {
        this.$store = context.$store;
        this.redirect = context.redirect;
      }
      const headers = {
        Authorization:
          "Basic " +
          base64url(env.auth_api_client_id + ":" + env.auth_api_client_secret)
      };
      let result;
      try {
        result = await axios.post(
          env.auth_api_client_url + "auth/",
          {
            grant_type: "password",
            username,
            password
          },
          {
            headers
          }
        );
      } catch (error) {
        await this.$store.dispatch("createError", {
          text: "Benutzername oder Passwort falsch!",
          ...error
        });
        if (context) {
          context.showForm = true;
        }
      }
      const token = result?.data?.access_token;
      if (token) {
        localStorage.removeItem("impersonatedBy");
        const decode = jwt.decode(token);
        localStorage.setItem(
          "session",
          JSON.stringify({
            token: token,
            user_id: decode.sub,
            scopes: decode.scope?.split(" ") ?? [],
            // PHPs Date Number hat 3 stellen weniger als die von JS.
            // Man landet immer in den 70ern wenn man die 3 stellen nicht anhängt
            expires: decode.exp * 1000
          })
        );

        localStorage.setItem("authRefreshToken", result?.data?.refresh_token);
        this.$store.state.session = {
          id: decode.sub,
          expires: decode.exp * 1000
        };
        if (this.redirect) {
          router.push(this.prev || "/");
        } else {
          this.$emit("success");
        }
      }
    },
    async sendChangePwLink() {
      this.sendingEmail = true;
      let result;
      try {
        result = await axios.post(
          env.auth_api_client_url + "users/requestChangePwLink",
          {
            email: this.changePwEmail
          }
        );
      } catch (err) {
        console.error(err);
      }
      if (result?.data?.message === "sendChangePwLink") {
        await this.$store.dispatch(
          "createSuccess",
          "Passwort-Ändern-E-Mail versendet!"
        );
      } else {
        await this.$store.dispatch("createError", {
          text: "Fehler beim versenden der Passwort-Ändern-E-Mail"
        });
      }
      this.sendingEmail = false;
      this.pwForgotten = false;
    }
  },
  computed: {
    globalConfig() {
      return this.$store.state.globalEoConfig;
    }
  }
};
